import { PubTournament } from "../../../../../../../api/types";
import PremiumPubTournamentTimer from "../tournament-timer";
import {
  PremiumPubTournamentBlind,
  PremiumPubTournamentBlindWrapper,
  PremiumPubTournamentButton,
  PremiumPubTournamentButtonWrapper,
  PremiumPubTournamentContent,
  PremiumPubTournamentContentWrapper,
  PremiumPubTournamentHeader,
  PremiumPubTournamentHeaderTitle,
  PremiumPubTournamentState,
  PremiumPubTournamentWrapper,
} from "./style";
import { usePubTournament } from "../../../../hooks/use-pub-tournament";
import {
  getPlayersText,
  getLevelText,
  getCurrentBlindTitle,
  getBlindValue,
  getEntryButtonText,
} from "../../../../../../../utils/tournament";

interface PremiumPubTournamentItemProps {
  item: PubTournament;
}
const PremiumPubTournamentItem = ({ item }: PremiumPubTournamentItemProps) => {
  const {
    canReservation,
    getReservationButtonText,
    handleClickStateButton,
    handleClickButton,
    isReservation,
  } = usePubTournament(item);

  return (
    <PremiumPubTournamentWrapper>
      <PremiumPubTournamentHeader>
        <PremiumPubTournamentHeaderTitle>
          <div className="main">{item.title}</div>
          <div className="sub">{item.subTitle}</div>
        </PremiumPubTournamentHeaderTitle>
        <div className="player">
          PLAYERS <span>{getPlayersText(item)}</span>
        </div>
      </PremiumPubTournamentHeader>
      <PremiumPubTournamentContentWrapper>
        <div className="timer">
          <PremiumPubTournamentTimer timer={item.timeInfo} radius={28.5} />
        </div>
        <PremiumPubTournamentContent>
          <div className="level">{getLevelText(item)}</div>
          <PremiumPubTournamentBlindWrapper>
            <PremiumPubTournamentBlind isNext={false}>
              <div className="name">{getCurrentBlindTitle(item)}</div>
              <div className="value">{getBlindValue(item, "current")}</div>
            </PremiumPubTournamentBlind>
            <PremiumPubTournamentBlind isNext={true}>
              <div className="name">다음 BLINDS</div>
              <div className="value">{getBlindValue(item, "next")}</div>
            </PremiumPubTournamentBlind>
          </PremiumPubTournamentBlindWrapper>
        </PremiumPubTournamentContent>
      </PremiumPubTournamentContentWrapper>
      <PremiumPubTournamentButtonWrapper>
        <PremiumPubTournamentState onClick={handleClickStateButton}>
          <img src="/image-web/reservation/state_button.svg" alt="state" />
          <div className="count">{getEntryButtonText(item)}</div>
        </PremiumPubTournamentState>
        <PremiumPubTournamentButton
          isOpen={item.reservation ? canReservation() : true}
          isReservation={isReservation}
          onClick={handleClickButton}
        >
          {getReservationButtonText()}
        </PremiumPubTournamentButton>
      </PremiumPubTournamentButtonWrapper>
    </PremiumPubTournamentWrapper>
  );
};

export default PremiumPubTournamentItem;
